<template>
    <div>
        <b-modal id="bes-calculate" title="Bes Hesaplama" scrollable no-close-on-esc no-close-on-backdrop>
            <monthly-bes-calculate v-model="check"></monthly-bes-calculate>
            <template #modal-footer><v-executer text="Hesapla" :disabled="!canCalculate" :action="calculate" :loading="calculating"></v-executer></template>
        </b-modal>


        <v-table    ref="table"
                    :items-provider="provider"
                    :initial-load="false"
                    :fields="fields"
                    pagination="server"
                    search>
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <select class="form-control" v-model="month">
                                        <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <select class="form-control" v-model="year">
                                        <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                    </select>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <v-select-list :options="options" v-model="SIRA_NO" label="name" placeholder="Hesaplama"></v-select-list>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-success btn-block" v-on:click="fetch">
                                        Sorgula
                                    </button>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-primary btn-block" v-on:click="$showModal('bes-calculate')">
                                        Hesaplama
                                    </button>
                                </div>
                            </div>
                        </template>
                    </v-table>
    </div>
</template>

<script>
import moment from 'moment'
import MonthlyBesCalculate from './MonthlyBesCalculate.vue' 
import EmployeeOperationsApi from '@/api/employee-operations';

export default{
    props:{
        months:Array
    },
    components:{
        MonthlyBesCalculate
    },
    data(){
        return {
            year:null,
            years:[],
            month:null,
            fields:[
                {name:'Sicil Numarası',key:'SICIL_NO',thClass:'w-25'},
                {name:'Kimlik Numarası',key:'IdentityNumber',thClass:'w-25'},
                {name:'Personel',key:'FullName',thClass:'w-25',tdClass:'text-nowrap'},
                {name:'Durum',key:'Errors',component:true,componentOptions:{name:"monthly-score-bes-result/MonthlyScoreBesResult"},thClass:'w-25'},
            ],
            calculating:false,
            check:{
                agesa:false,
                score:false,
                kykm:false,
                netsis:false,
                kykmBrut:false,
                netsisBilgiGiris:false,
                order:false,
                SIRA_NO:null
            },
            SIRA_NO:null,
            options:[
                {name:'BES',value:'13'},
                {name:'İcra',value:'2'}
            ]
        }
    },
    mounted(){
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.EmployeeExceptionalKYKMCalculationStatusTable({
                Month:this.month,
                Year:this.year,
                Driver:true,
                SIRA_NO:this.SIRA_NO ? this.SIRA_NO.value : null ,
                TIP:this.SIRA_NO ? 3 : null ,
                PaginationRequest:data
            })
        },
        calculate(){
            this.calculating = true
            EmployeeOperationsApi.EmployeeExceptionalKYKMCalculate({
                Month:this.month,
                Year:this.year,
                SIRA_NO:this.check.SIRA_NO,
                TIP:3,
                Driver:true
            }).then(res => {
                this.$result(res)
                this.calculating = false
                if(res.data.Success){
                    this.fetch()
                }
            }).catch(err => {
                this.$result(null,err)
                this.calculating = false
            })
        },
        fetch(){
            this.$refs.table.refresh()
        },
        getCurrentYear(){
            this.year = moment().format('YYYY')
            this.showingYear = this.year
        },
        configureYears(){
            let years = []
            let year = 2015
            while(year <= this.year){
                years.push(year)
                year ++
            }
            this.years = years
        },
        getCurrentMonth(){
            let current = moment().month() + 1
            this.month = this.months.find(m=>m.index == current)?.index || 0
            this.showingMonth = this.month
        },
    },
    computed:{
        canCalculate(){
            const res = this.check.score &&
                    this.check.kykm &&
                    this.check.netsis &&
                    this.check.kykmBrut &&
                    this.check.netsisBilgiGiris &&
                    this.check.order
            
            if(this.check.SIRA_NO == '13'){ return res && this.check.agesa }
            else if(this.check.SIRA_NO == '2') return res && true
            else return res && false
        }
    }
}
</script>